module.exports = __webpack_public_path__ + "static/media/icon-logout-white.50360b34.svg";